import { Link } from "react-router-dom";
import { LanguageSelector } from "@/components/ui/language-selector";
import { Icon } from "@/lib/icons";
import { HeaderThemeToggle } from "./HeaderThemeToggle";
import { SiteHeaderBar } from "./SiteHeaderBar";

/**
 * Header of the public website for an admin, moderator or accountant who
 * opened it from their panel: no contribution menu (those pages are not
 * theirs), only the way back to their own space.
 */
export function BackOfficeSiteHeader({ lang, homeHref }: { lang: string; homeHref: string }) {
  const label = lang === "en" ? "My space" : "Mon espace";
  return (
    <SiteHeaderBar
      lang={lang}
      actions={
        <>
          <LanguageSelector variant="header" className="hidden md:inline-flex" />
          <HeaderThemeToggle />
          <Link
            to={homeHref}
            className="ml-1 inline-flex h-10 items-center gap-2 rounded-full bg-primary px-4 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90 focus-ring"
          >
            <Icon name="layoutDashboard" className="size-4" aria-hidden />
            {label}
          </Link>
        </>
      }
    />
  );
}
